<template>
  <v-dialog
    v-model="showErrorDialog"
    persistent
    max-width="290"
  >
    <v-card v-if="errorDialogData">
      <v-card-title
        v-if="errorDialogData"
        class="text-h5 red lighten-2"
      >
        <b class="white--text text--lighten-1">Error</b>
      </v-card-title>

      <v-card-text v-if="typeof errorDialogData === 'object'">
        <br>
        <b>HTTP Code</b>: {{ errorDialogData.status }} <br>
        <b>Error Code</b>: {{ errorDialogData.errorCode || null }} <br>
        <br>
        {{ errorDialogData.message }}
      </v-card-text>
      <v-card-text v-else>
        <br>
        <b>HTTP Code</b>: 400 <br>
        <br>
        {{ errorDialogData }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="red darken-1"
          text
          @click="onHideErrorDialog"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseErrorDialog",
  computed: {
    showErrorDialog() {
      return this.$store.getters["AppStore/getErrorDialogState"];
    },
    errorDialogData() {
      return this.$store.getters["AppStore/getErrorDialogData"];
    }
  },
  methods: {
    onHideErrorDialog() {
      this.$store.dispatch("AppStore/clearErrorDialogData");
    }
  }
};
</script>

<style lang="scss" scoped></style>
